export default "__VITE_ASSET__6453fd03__"